import Inputmask from 'inputmask';

const prev = Inputmask.prototype.aliases.numeric.onKeyDown;
Inputmask.prototype.aliases.numeric.onKeyDown = function (e: KeyboardEvent, buffer, caretPos, opts) {
  if (e.code === 'NumpadSubtract') {
    e = new KeyboardEvent('keydown', ({ ...e, ...{ keyCode: 189 } }));
  } else if (e.code === 'NumpadAdd') {
    e = new KeyboardEvent('keydown', ({ ...e, ...{ keyCode: 187, shiftKey: true } }));
  }
  prev.call(this, e, buffer, caretPos, opts);
};
